/**
 * WordPress dependencies
 * @wordpress/i18n for translation functions
 * - https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 * - Should basically always be used for any text that is visible to the user
 *
 * @wordpress/element for React components
 * - https://developer.wordpress.org/block-editor/reference-guides/packages/packages-element/
 */
// import CourseListItem from './CourseListItem';
import { __ } from '@wordpress/i18n';
import { decodeEntities } from '@wordpress/html-entities';
import CourseListItemStatus from './CourseListItemStatus';

/**
 * Example Component
 * @param {Object.data} data Data from UseInfiniteQuery and useRecipes hook
 * @param {Object.currentPage} currentPage The current page of the recipe list
 * @param {Object.isPending} isPending Whether the loading is pending or not (from useIndustries hook)
 * @param {Object.error} error The error of the data fetch (from useRecipes hook)
 * @param {Object.isError} isError Whether the fetch has an error or not (from useIndustries hook)
 * @returns {JSX.Element}
 */
function CourseList({ data, isPending }) {
	if (isPending) {
		return (
			<div className="course-list" data-status="loading">
				<p className="course-list__state-message">
					{__('Loading...', 'kotisivu-block-theme')}
				</p>
			</div>
		);
	}

	if (!data) {
		return (
			<div className="course-list" data-status="not-found">
				<p className="course-list__state-message">
					{__('No courses found', 'kotisivu-block-theme')}
				</p>
			</div>
		);
	}

	return (
		<ul className="course-list" data-status="loaded">
			{data.map((course) => (
				<li key={course.id} className="course-list-item">
					<div className="course-list-item__image-wrapper">
						<img
							className="course-list-item__image"
							src={course.metadata.image?.url}
							width={course.metadata.image?.width}
							height={course.metadata.image?.height}
							alt={course.metadata.image?.alt}
							title={course.metadata.image?.title}
						/>
						<CourseListItemStatus
							instances={course.metadata.instances}
						/>
					</div>
					<h2 className="course-list-item__heading">
						{decodeEntities(course.metadata?.title)}
					</h2>
					<div className="course-list-item__category">
						<span className="course-list-item__category-label">
							{__('Category', 'kotisivu-block-theme')}
						</span>
						{course.metadata?.categories.map((category) => (
							<span
								key={category.term_id}
								className="course-list-item__category-item"
							>
								{decodeEntities(category.name)}
							</span>
						))}
					</div>
					<p className="course-list-item__description">
						{decodeEntities(course.metadata?.excerpt)}
					</p>
					<div className="course-list-item__button wp-block-button is-style-fill">
						<a
							className="course-list-item__link wp-block-button__link wp-element-button"
							href={course.link}
						>
							{__('Read more', 'kotisivu-block-theme')}
						</a>
					</div>
				</li>
			))}
		</ul>
	);
}

export default CourseList;
